import {createSlice} from "@reduxjs/toolkit";


const userSlice = createSlice({
    name: "user",
    initialState: {
        data: {
            coupons: [],
            has_active_order: null,
        },
        token: (() => {
            const params = new URLSearchParams(window.location.search);
            // Telegram: telegram_auth_token в URL
            const tgToken = params.get("telegram_auth_token");
            if (tgToken) return tgToken;
            // MAX: start_param из WebApp.initDataUnsafe
            try {
                const maxToken = window.WebApp?.initDataUnsafe?.start_param;
                if (maxToken) return maxToken;
            } catch (e) {}
            return null;
        })(),
        loaded: false
    },
    reducers: {
        setUserData: (state, action) => {
            state.data = action.payload;
            state.loaded = true;
        },
    },
});


export default userSlice;
